import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=ec2523ea&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts&setup=true"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Home.vue?vue&type=style&index=0&id=ec2523ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.1_webpack@5.74.0_esbuild@0.28.1___lodash@4.17.21_pret_109f61365412ffe5355524363be3c32c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2523ea",
  null
  
)

export default component.exports